import _ from 'lodash';

const root = state => _.get(state, 'ControlInformationState.recipeGroup');

export const getRecipeGroupError = state => _.get(root(state), 'error', null);

export const getRecipeGroupLoading = state =>
  _.get(root(state), 'loading', false);

export const getRecipeGroupSaved = state =>
  _.get(root(state), 'writeSuccessful', false);

export const getRecipeGroupDeleted = state =>
  _.get(root(state), 'deleteSuccessful', false);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/recipeGroup/selectors.js